import { Link } from 'react-router-dom';
import { categories } from '@/mocks/comics';

export default function CategoryGrid() {
  return (
    <section className="py-16 md:py-20 bg-background-100" aria-labelledby="category-heading">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-12">
          <h2 id="category-heading" className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
            漫画分类
          </h2>
          <p className="text-sm text-foreground-500 mt-2">探索你喜欢的漫画类型，发现更多精彩作品</p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group bg-background-50 rounded-xl p-5 md:p-6 hover:bg-background-50 transition-all cursor-pointer border border-background-200/60 hover:border-primary-200/60"
            >
              <div className="w-11 h-11 md:w-12 md:h-12 rounded-xl bg-accent-100 flex items-center justify-center mb-4 group-hover:bg-accent-200 transition-colors">
                <i className={`${cat.icon} text-xl text-accent-700`}></i>
              </div>
              <h3 className="text-base font-semibold text-foreground-900 mb-1.5">
                {cat.name}
              </h3>
              <p className="text-xs text-foreground-500 leading-relaxed">
                {cat.description}
              </p>
              <div className="flex items-center gap-1.5 mt-3 text-xs text-primary-600 font-medium opacity-0 group-hover:opacity-100 transition-opacity">
                浏览漫画
                <i className="ri-arrow-right-line"></i>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}